import request from '@/utils/request'

export function getConsultationPage(params) {
  return request({
    url: '/admin/consultation/page',
    method: 'get',
    params
  })
}

export function getConsultationList(params) {
  return request({
    url: '/admin/consultation/list',
    method: 'get',
    params
  })
}

export function getConsultationDetail(id) {
  return request({
    url: `/admin/consultation/${id}`,
    method: 'get'
  })
}

export function createConsultation(data) {
  return request({
    url: '/admin/consultation',
    method: 'post',
    data
  })
}

export function updateConsultation(data) {
  return request({
    url: '/admin/consultation',
    method: 'put',
    data
  })
}

export function deleteConsultation(ids) {
  return request({
    url: '/admin/consultation',
    method: 'delete',
    data: ids
  })
}

export function updateConsultationStatus(id, status, remark, handleResult) {
  return request({
    url: `/admin/consultation/${id}/status`,
    method: 'put',
    params: { status, remark, handleResult }
  })
}

export function getConsultationStatistics(params) {
  return request({
    url: '/admin/consultation/statistics',
    method: 'get',
    params
  })
}

export function getConsultationLogs(targetId) {
  return request({
    url: '/api/logs/page',
    method: 'get',
    params: { targetType: 'consultation', targetId, limit: 50, page: 1 }
  })
}

export function uploadConsultationFile(data, onUploadProgress) {
  return request({
    url: '/admin/consultation/upload',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 600000,
    onUploadProgress
  })
}
